import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { rentalSchemeOptionsAPI } from "../api/onboarding";
import { addressStateCityPincode } from "../api/common";

export const rentalSchemeOptions = createAsyncThunk(
  "dashboard/rental-scheme",
  async (hubmanagerId) => {
    try {
      const response = await rentalSchemeOptionsAPI(hubmanagerId);
      return response.results;
    } catch (error) {
      return error;
    }
  }
);

const rentalSchemeOptionsSlice = createSlice({
  name: "rentalSchemeOptions",
  initialState: {
    data: [],
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(rentalSchemeOptions.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(rentalSchemeOptions.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.driverId = state.data.id;
    });
    builder.addCase(rentalSchemeOptions.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});
// export const driverDetailsWithId = driverDetailsWithIdSlice.reducer;

export const getStatesList = createAsyncThunk("/states", async () => {
  try {
    const response = await addressStateCityPincode();
    return response.results.states;
  } catch (error) {
    return error;
  }
});

const stateOptionsRedux = createSlice({
  name: "stateOptions",
  initialState: {
    data: [],
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStatesList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getStatesList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(getStatesList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});
const documentModal = createSlice({
  name: "documentModal",
  initialState: {
    value: "",
    downloadable: false,
    title: "",
    error: null,
    isLoading: false,
  },
  reducers: {
    setDocumentModalValue: (state, action) => {
      state.value = action.payload?.value;
      state.downloadable = action.payload?.downloadable;
      state.title = action.payload?.title;
    },
    clearDocumentModalValue: (state, action) => {
      state.value = "";
      state.downloadable = false;
      state.title = "";
    },
  },
});

export const rentalSchemeDetails = rentalSchemeOptionsSlice.reducer;
export const stateOptions = stateOptionsRedux.reducer;
export const documentsModal = documentModal.reducer;
export const setDocumentModalValue = documentModal.actions.setDocumentModalValue;
export const clearDocumentModalValue = documentModal.actions.clearDocumentModalValue;
// export default rentalSchemeOptionsSlice.reducer;
